import { heightS, heightM, heightB } from '../constants/common';
export default {
  methods: {
    styleComputor() {
      const scale = innerWidth / 750;
      let nowHeight = 750 * (innerHeight / innerWidth);

      let appHeight = this.appHeight;

      if (appHeight !== 0) {
        nowHeight = appHeight / (innerWidth / 750);
      }

      // 样式选择
      function chooser(s, m, b) {
        return nowHeight <= heightS ? s : nowHeight <= heightM ? m : b;
      }

      let res = {};
      // bg
      res.bgArr = [
        {
          url: require('../assets/images/home/bg-s.jpg'),
          height: heightS
        },
        {
          url: require('../assets/images/home/bg-m.jpg'),
          height: heightM
        },
        {
          url: require('../assets/images/home/bg.jpg'),
          height: heightB
        }
      ];

      // btn
      res.btnDraw = {
        src: require('../assets/images/home/btn-draw.png'),
        pos: [
          {
            left: -244,
            top: 216,
            height: heightS
          },
          {
            left: -244,
            top: 213,
            height: heightM
          },
          {
            left: -244,
            top: 266,
            height: heightB
          }
        ],
        size: {
          width: 490,
          height: 91
        }
      };
      res.btnJump = {
        src: require('../assets/images/home/btn-jump.png'),
        pos: [
          {
            left: -244,
            top: 347,
            height: heightS
          },
          {
            left: -244,
            top: 344,
            height: heightM
          },
          {
            left: -244,
            top: 397,
            height: heightB
          }
        ],
        size: {
          width: 490,
          height: 91
        }
      };
      res.btnRule = {
        src: require('../assets/images/home/btn-rule.png'),
        pos: [
          {
            left: -65,
            top: 472,
            height: heightS
          },
          {
            left: -65,
            top: 489,
            height: heightM
          },
          {
            left: -65,
            top: 582,
            height: heightB
          }
        ],
        size: {
          width: 118,
          height: 31
        }
      };
      res.btnRuleConfirm = {
        src: require('../assets/images/home/btn-rule-confirm.png'),
        pos: [
          {
            left: -111,
            top: 204,
            height: heightS
          },
          {
            left: -111,
            top: 286,
            height: heightB
          }
        ],
        size: {
          width: 222,
          height: 88
        }
      };

      // img
      res.title = {
        src: require('../assets/images/home/title.png'),
        pos: [
          {
            left: -419,
            top: -35,
            height: heightS
          },
          {
            left: -419,
            top: -48,
            height: heightM
          },
          {
            left: -419,
            top: -15,
            height: heightB
          }
        ],
        size: {
          width: 765,
          height: 354
        }
      };

      res.logo = {
        src: require('../assets/images/home/logo.png'),
        pos: [
          {
            left: -157,
            top: -487,
            height: heightS
          },
          {
            left: -157,
            top: -530,
            height: heightM
          },
          {
            left: -157,
            top: -627,
            height: heightB
          }
        ],
        size: {
          width: 314,
          height: 118
        }
      };

      const ruleWrapperSmall = {
        src: require('../assets/images/home/rule-wrapper-s.png'),
        pos: [
          {
            left: -375,
            top: -750,
            height: heightS
          }
        ],
        size: {
          width: 750,
          height: 1500
        }
      };
      const ruleWrapperMid = {
        src: require('../assets/images/home/rule-wrapper-m.png'),
        pos: [
          {
            left: -375,
            top: -604.59,
            height: 1300
          }
        ],
        size: {
          width: 750,
          height: 1206
        }
      };
      const ruleWrapperBig = {
        src: require('../assets/images/home/rule-wrapper.png'),
        pos: [
          {
            left: -375,
            top: -750,
            height: heightB
          }
        ],
        size: {
          width: 750,
          height: heightB
        }
      };
      res.ruleWrapper = chooser(
        ruleWrapperSmall,
        ruleWrapperMid,
        ruleWrapperBig
      );

      // popup
      res.popupBg = {
        src: require('../assets/images/popup/bg.png'),
        pos: [
          {
            left: -254,
            top: -356,
            height: heightS
          },
          {
            left: -254,
            top: -409,
            height: heightM
          },
          {
            left: -254,
            top: -409,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 738
        }
      };
      res.popuptitles = [
        {
          src: require('../assets/images/popup/10.png'),
          pos: [
            {
              left: -127,
              top: -282,
              height: heightS
            },
            {
              left: -127,
              top: -335,
              height: heightB
            }
          ],
          size: {
            width: 249,
            height: 248
          }
        },
        {
          src: require('../assets/images/popup/30.png'),
          pos: [
            {
              left: -127,
              top: -282,
              height: heightS
            },
            {
              left: -127,
              top: -335,
              height: heightB
            }
          ],
          size: {
            width: 249,
            height: 248
          }
        },
        {
          src: require('../assets/images/popup/50.png'),
          pos: [
            {
              left: -127,
              top: -282,
              height: heightS
            },
            {
              left: -127,
              top: -335,
              height: heightB
            }
          ],
          size: {
            width: 249,
            height: 248
          }
        }
      ];

      res.grabed = {
        src: require('../assets/images/popup/grabed.png'),
        pos: [
          {
            left: -254,
            top: -356,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 738
        }
      };

      res.btnGrab = {
        src: require('../assets/images/popup/btn-grab.png'),
        pos: [
          {
            left: -111,
            top: 179,
            height: heightS
          },
          {
            left: -111,
            top: 126,
            height: heightB
          }
        ],
        size: {
          width: 222,
          height: 88
        }
      };
      res.btnClose = [
        {
          src: require('../assets/images/popup/btn-close.png'),
          pos: [
            {
              left: -41,
              top: 393,
              height: heightS
            },
            {
              left: -41,
              top: 393,
              height: heightM
            },
            {
              left: -41,
              top: 393,
              height: heightB
            }
          ],
          size: {
            width: 91,
            height: 91
          }
        },
        {
          src: require('../assets/images/popup/btn-close.png'),
          pos: [
            {
              left: -41,
              top: 393,
              height: heightS
            },
            {
              left: -41,
              top: 340,
              height: heightM
            },
            {
              left: -41,
              top: 340,
              height: heightB
            }
          ],
          size: {
            width: 91,
            height: 91
          }
        },
        {
          src: require('../assets/images/popup/btn-close.png'),
          pos: [
            {
              left: -41,
              top: 176,
              height: heightS
            },
            {
              left: -41,
              top: 176,
              height: heightM
            },
            {
              left: -41,
              top: 176,
              height: heightB
            }
          ],
          size: {
            width: 91,
            height: 91
          }
        },
      ];
      res.btnCheck = {
        src: require('../assets/images/popup/btn-check.png'),
        pos: [
          {
            left: -111,
            top: 127,
            height: heightM
          },
          {
            left: -111,
            top: 120,
            height: heightB
          }
        ],
        size: {
          width: 222,
          height: 88
        }
      };

      res.busy = {
        src: require('../assets/images/popup/busy.png'),
        pos: [
          {
            left: -254,
            top: -309,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 526
        }
      };
      res.busyLimited = {
        src: require('../assets/images/popup/busy-limited.png'),
        pos: [
          {
            left: -254,
            top: -309,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 526
        }
      };

      const ruleTextWrapperSmall = {
        pos: [
          {
            left: -223,
            top: -284.6,
            height: heightS
          }
        ],
        size: {
          width: 450,
          height: 420
        }
      };

      const ruleTextWrapperMid = {
        pos: [
          {
            left: -227.5,
            top: -334.5,
            height: heightM
          }
        ],
        size: {
          width: 450,
          height: 522
        }
      };

      const ruleTextWrapperBig = {
        pos: [
          {
            left: -223,
            top: -415,
            height: heightB
          }
        ],
        size: {
          width: 450,
          height: 670
        }
      };

      res.ruleTextWrapper = chooser(
        ruleTextWrapperSmall,
        ruleTextWrapperMid,
        ruleTextWrapperBig
      );

      const ruleShadowSmall = {
        pos: [
          {
            left: -223,
            top: 93,
            height: heightS
          }
        ],
        size: {
          width: 450,
          height: 45
        }
      };
      const ruleShadowMid = {
        pos: [
          {
            left: -223,
            top: 138,
            height: heightM
          }
        ],
        size: {
          width: 450,
          height: 55
        }
      };
      const ruleShadowBig = {
        pos: [
          {
            left: -223,
            top: 195,
            height: heightB
          }
        ],
        size: {
          width: 450,
          height: 65
        }
      };

      res.ruleShadow = chooser(ruleShadowSmall, ruleShadowMid, ruleShadowBig);

      res.beforeEvent = {
        src: require('../assets/images/popup/before-event.png'),
        pos: [
          {
            left: -254,
            top: -309,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 526
        }
      };
      res.afterEvent = {
        src: require('../assets/images/popup/after-event.png'),
        pos: [
          {
            left: -254,
            top: -409,
            height: heightB
          }
        ],
        size: {
          width: 514,
          height: 738
        }
      };

      // loading

      res.loadingBg = [
        {
          url: require('../assets/images/loading/bg-s.jpg'),
          height: heightS
        },
        {
          url: require('../assets/images/loading/bg-m.jpg'),
          height: heightM
        },
        {
          url: require('../assets/images/loading/bg.jpg'),
          height: heightB
        }
      ];
      res.barOuter = {
        src: require('../assets/images/loading/loading-outer.png'),
        pos: [
          {
            left: -313,
            top: -90.5,
            height: heightB
          }
        ],
        size: {
          width: 627,
          height: 196
        }
      };
      res.barInner = {
        src: require('../assets/images/loading/loading-inner.png'),
        pos: [
          {
            left: -277,
            top: -22,
            height: heightB
          }
        ],
        size: {
          width: 1,
          height: 16
        }
      };

      return res;
    }
  }
};
